// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__DAL4d","left":"form_left__Hy9Sh","right":"form_right__097mY","inputo":"form_inputo__4IU4p"};